import { IconButton, Stack, Tooltip, Typography } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { PUBLIC_REGISTRY_LABEL } from "../../constants";
import { MatchBasisLegend } from "./MatchBasisLegend";
import { RegistryTagChip } from "./RegistryTagChip";
import type { CorporateRegistryTag } from "../../types";

interface Props {
  tags: CorporateRegistryTag[];
}

/**
 * 詳細の見出しに置く「公表情報」のタグの行。見出しの横の ? でマークの意味を出す
 * @param props.tags 法人に付いたタグ
 * @returns タグの行。タグが無ければ何も出さない
 */
export const RegistryTagChips: React.FC<Props> = ({ tags }) => {
  if (!tags.length) return null;
  return (
    <Stack spacing={0.75}>
      <Stack direction="row" spacing={0.5} alignItems="center">
        <Typography variant="caption" color="text.secondary" fontWeight={500}>
          {PUBLIC_REGISTRY_LABEL}
        </Typography>
        <Tooltip
          title={<MatchBasisLegend color="inherit" />}
          arrow
          enterTouchDelay={0}
          leaveTouchDelay={5000}
        >
          <IconButton
            size="small"
            aria-label={`${PUBLIC_REGISTRY_LABEL}の見方`}
            sx={{ p: 0.25 }}
          >
            <HelpOutlineIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </Tooltip>
      </Stack>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        {tags.map((tag) => (
          <RegistryTagChip key={tag.code} tag={tag} />
        ))}
      </Stack>
    </Stack>
  );
};
